import React, { Component } from 'react';
import { ROOT_URL } from '../../../actions';
import Axios from 'axios';
import { Tabs, Tab, Container } from 'react-bootstrap';
import WrongCategoryFeedback from './wrong-category-feedback';
import ProductNotSoldFeedback from './product-not-sold-feedback';
import FavorableVendorFeedback from './favorable-vendor-feedback';
import InVendorFeedback from './in-vendor-feedback';
import BuysellRepVendorFeedback from './buysell-rep-vendor-feedback';
import LpgVendorFeedback from './lpg-vendor-feedback';
import OutVendorFeedback from './out-vendor-feedback';
import MemberCompany from './Member_Company';
import BranchCompany from './Branch_Company';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import 'react-toastify/dist/ReactToastify.min.css';

class Feedback extends Component {

    changeTab = (tabName) => {
        console.log('Tab changed to ', tabName);
    };
    componentDidMount() {
        Axios.get(ROOT_URL +`/track?tabId=14`).then((res) => {return Promise.resolve(res.data);
        }).catch((error) => {
            console.log('error', error);
            return Promise.reject(error);
        })
    }

    render() {
        return (
            <Container fluid>
                 <ToastContainer style={{zIndex: '9999'}}  />
                <Tabs defaultActiveKey="wrongCategory" id="uncontrolled-tab-example" onSelect={(k) => this.changeTab(k)}>
                    <Tab eventKey="wrongCategory" title="Wrong Category">
                        <WrongCategoryFeedback />
                    </Tab>
                    <Tab eventKey="favorableVendor" title="Favorable Supplier">
                        <FavorableVendorFeedback />
                    </Tab>
                    <Tab eventKey="productNotSold" title="Product Not Sold">
                        <ProductNotSoldFeedback />
                    </Tab>
                    <Tab eventKey="inVendor" title="IN Supplier">
                        <InVendorFeedback />
                    </Tab>
                    <Tab eventKey="buySellRep" title="Buysell Rep Supplier">
                        <BuysellRepVendorFeedback />
                    </Tab>
                    <Tab eventKey="lpgVendor" title="LPG Supplier">
                        <LpgVendorFeedback />
                    </Tab>
                    <Tab eventKey="outVendor" title="Out Supplier">
                        <OutVendorFeedback />
                    </Tab>
                    <Tab eventKey="MemberCompany" title="Member Company">
                        <MemberCompany />
                    </Tab>
                    <Tab eventKey="BranchCompany" title="Branch Company">
                        <BranchCompany />
                    </Tab>
                </Tabs>
            </Container>
        );
    }
}

export default Feedback;